const ACTION_PREPEND = '@@ui';

export const SCREEN_RESIZE = `${ACTION_PREPEND}/SCREEN_RESIZE`;
export const SCREEN_ORIENTATION = `${ACTION_PREPEND}/SCREEN_ORIENTATION`;
export const BROWSER_TYPE = `${ACTION_PREPEND}/BROWSER_TYPE`;

export const screenResize = payload => ({
  type: SCREEN_RESIZE,
  payload
});

export const screenOrientation = payload => ({
  type: SCREEN_ORIENTATION,
  payload
});

export const browserType = payload => ({
  type: BROWSER_TYPE,
  payload
});
